
export const getInitials = (name: string): string => {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase();
};

export const formatSummary = (summary?: string): string => {
  if (!summary) return "";
  
  let formattedSummary = summary;
  
  if (summary.trim().startsWith('{') && summary.trim().endsWith('}')) {
    try {
      const summaryJson = JSON.parse(summary);
      if (summaryJson.summary) {
        if (typeof summaryJson.summary === 'object') {
          const paragraphs = [];
          if (summaryJson.summary.paragraph1) paragraphs.push(summaryJson.summary.paragraph1);
          if (summaryJson.summary.paragraph2) paragraphs.push(summaryJson.summary.paragraph2);
          formattedSummary = paragraphs.join("\n\n");
        } else {
          formattedSummary = summaryJson.summary;
        }
      } 
      else if (summaryJson.paragraph1) {
        const paragraphs = [];
        if (summaryJson.paragraph1) paragraphs.push(summaryJson.paragraph1);
        if (summaryJson.paragraph2) paragraphs.push(summaryJson.paragraph2);
        formattedSummary = paragraphs.join("\n\n");
      }
    } catch (e) {
      console.error("Error parsing summary JSON:", e);
    }
  }
  
  return formattedSummary;
};
